"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonMessages = void 0;
var authTemplates_1 = __importDefault(require("./authTemplates"));
var dummyScreen_1 = __importDefault(require("./dummyScreen"));
var general_1 = __importDefault(require("./general"));
var unitTitles_1 = __importDefault(require("./general/unitTitles"));
var task_1 = __importDefault(require("./task"));
var team_1 = __importDefault(require("./team"));
var menu_1 = __importDefault(require("./menu"));
var registration_1 = __importDefault(require("./registration"));
var dashboard_1 = __importDefault(require("./dashboard"));
var user_1 = __importDefault(require("./user"));
var fleet_1 = __importDefault(require("./fleet"));
var pagination_1 = __importDefault(require("./pagination"));
var phoneNumber_1 = __importDefault(require("./phoneNumber"));
var business_1 = __importDefault(require("./business"));
var businessTypes_1 = __importDefault(require("./businessTypes"));
var farmTypes_1 = __importDefault(require("./farmTypes"));
var smartFarming_1 = __importDefault(require("./smartFarming"));
var landingPage_1 = __importDefault(require("./landingPage"));
var dataAndPrivacy_1 = __importDefault(require("./dataAndPrivacy"));
var cpq_1 = __importDefault(require("./cpq"));
var categories_1 = __importDefault(require("./categories"));
exports.commonMessages = {
    dummyScreen: dummyScreen_1.default,
    general: general_1.default,
    unitTitles: unitTitles_1.default,
    task: task_1.default,
    team: team_1.default,
    authTemplates: authTemplates_1.default,
    menu: menu_1.default,
    registration: registration_1.default,
    dashboard: dashboard_1.default,
    user: user_1.default,
    fleet: fleet_1.default,
    pagination: pagination_1.default,
    phoneNumber: phoneNumber_1.default,
    business: business_1.default,
    businessTypes: businessTypes_1.default,
    farmTypes: farmTypes_1.default,
    smartFarming: smartFarming_1.default,
    landingPage: landingPage_1.default,
    dataAndPrivacy: dataAndPrivacy_1.default,
    cpq: cpq_1.default,
    categories: categories_1.default,
};
